var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-page bg-white"},[_c('bulk-code-search'),_c('bulk-code-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }